<template>
    <!-- <v-row style="margin-left:0rem;">
        <v-col :cols="2" v-for="(p,index) in list" :key="index" style="padding:0;margin-right:0.3rem;margin-top:0.45rem;">
            <v-avatar size="36">
                <img :src="p.HEAD_IMAGE_URL" alt="1" >
            </v-avatar>
        </v-col>
    </v-row> -->
    <div>
      <v-row style="margin-left:0rem;" v-for="(p,index) in list" :key="index">
          <v-col :cols="2"  style="padding:0;margin-top:0.29rem;">
              <v-avatar size="36">
                  <img :src="p.HEAD_IMAGE_URL" alt="1" >
              </v-avatar>
          </v-col>
          <v-col :cols="10">
            <span v-if="p.USER_NAME">{{p.USER_NAME}}</span>
            <span v-else>{{p.NICK_NAME}}</span>
            <span v-if="workerCode === p.PY_CODE" style="color: #9b9b9b"> (处理人)</span>
          </v-col>
      </v-row>
    </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    orderCode: {
      type: String,
      default: ''
    },
    workerCode: {
      type: String,
      default: ''
    },
    userCode: {
      type: String,
      default: ''
    },
    functionDisabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      list: []
    }
  },
  computed: {
    curDisabled: {
      get() {
        return this.functionDisabled
      },
      set(val) {
        this.$emit('update:function-disabled', val)
      }
    }
  },
  mounted() {
    this.getList()
  },
  created() {
  },
  methods: {
    getList() {
      var that = this
      that.$api.bz.getPlayerList({ order_code: that.orderCode }).then(res => {
        // console.log('获取参与人列表', res);
        if (!res.success) {
          // that.$toast.warning('获取参与人列表失败');
          console.log('获取参与人列表失败', res);
          return;
        }
        var data = res.data
        that.list = data
        var flag = true
        for (let index = 0; index < that.list.length; index++) {
          var member = that.list[index]
          if (member.PY_CODE && member.PY_CODE === that.userCode) {
            that.curDisabled = false
            flag = false
          }
        }
        if (flag) {
          that.curDisabled = true
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
